(function importProcessControllerDefinition() {
    'use strict';

    angular.module('ImportProcess')
        .controller('ImportProcessDetailController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'importProcessService', '$stateParams', 'fileService',
            function importProcessController($scope, config, $state, $translate, errors, importProcessService, $stateParams, fileService) {
        $scope.load = function () {

            importProcessService.getById($stateParams.id)
                .then(function (result) {
                    $scope.import = result;
                    for (var i = 0; i < $scope.import.files.length; i++) {
                        $scope.import.files[i].fsize = fileService.FormatfileSize($scope.import.files[i].size);
                    }
                }, function (error) {
                    errors.showError(error);
                });
        }

        $scope.cancel = function () {
            $state.goBack('import-process-find');
        };

        $scope.downloadFile = function (file) {
            return importProcessService.downloadFile(file);
        };

        $scope.load();
    }
        ]);
})();